// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Cv2oJS {
  display: grid;
  width: 100%;
  height: 100%;
  max-height: 100vh;
  box-sizing: border-box;
  gap: var(--current-grid-gutter, 24px);
  padding: var(--current-grid-gutter, 24px);

  /* Mobile: 1 column (320px ~ 599px) */
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;
  grid-template-areas:
    'hero'
    'content';
}

/* Tablet: 2 columns with equal proportions (600px ~ 1023px) */
@media (min-width: 600px) {
  .Cv2oJS {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
    grid-template-areas: 'hero content';
    padding: 0;
    padding-right: 8px;
    gap: 0;

    margin-left: calc(var(--current-grid-gutter, 24px) * -1);
    padding-left: 0;
  }
}

/* Desktop (1024px+) */
@media (min-width: 1024px) {
  .Cv2oJS {
    grid-template-columns: 1fr 1fr;
  }
}

.hA_WCy {
  grid-area: hero;
  min-height: 200px;
}

/* Tablet and Desktop (600px+) */
@media (min-width: 600px) {
  .hA_WCy {
    min-height: 100%;
    max-height: 100%;
  }
}

.fzB687 {
  position: relative;
  width: 100%;
  height: 100%;
  border-top: 1px solid var(--public-layout-separator-color);
}

.JLDxUW {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.Imk5Gb {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 126px;
  z-index: 2;
  color: var(--image-text-color);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  h2 {
    font-family: var(--image-heading-font-family);
    font-size: var(--type-heading-lg-font-size);
    text-wrap: nowrap;
  }
  small {
    font-size: var(--font-size-md, 16px);
    font-family: var(--font-family-base);
    line-height: var(--line-height-160);
    max-width: 200px;
    text-wrap: wrap;
  }
}

.QeU160 {
  grid-area: content;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  position: relative;
  padding: var(--spacing-3, 24px);
}

.HQMmFC {
  background-color: var(--product-card-background);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--spacing-3, 24px);

  h3 {
    font-size: var(--font-size-xl);
    font-family: var(--font-family-base);

    text-align: center;
  }
}

.M56Btd {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3, 24px);
  list-style: none;
  padding: 0;
  padding-right: var(--spacing-2, 16px);
  font-size: var(--font-size-md, 16px);
  color: var(--product-card-title-color);
  text-align: left;

  li {
    display: flex;
    gap: var(--spacing-2, 16px);
  }
}

.in3V9L {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: auto;
  width: var(--font-size-3xl, 32px);
  height: var(--font-size-3xl, 32px);
  background: var(--product-card-icon-container-bg);
  border-radius: 50%;
  flex-shrink: 0;
}

.DWuF9H {
  .Imk5Gb {
    small {
      max-width: 290px;
    }
  }
}

.uuGG20 {
  background-color: var(--public-layout-background-color);
}

.HfKYUE {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./../../packages/contabilidade-digital/src/pages/LandingPage/LandigPageBase/LandingPageBase.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,qCAAqC;EACrC,yCAAyC;;EAEzC,qCAAqC;EACrC,0BAA0B;EAC1B,4BAA4B;EAC5B;;aAEW;AACb;;AAEA,8DAA8D;AAC9D;EACE;IACE,8BAA8B;IAC9B,uBAAuB;IACvB,mCAAmC;IACnC,UAAU;IACV,kBAAkB;IAClB,MAAM;;IAEN,wDAAwD;IACxD,eAAe;EACjB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,gCAAgC;AAChC;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,0DAA0D;AAC5D;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,UAAU;EACV,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;;EAEnB;IACE,6CAA6C;IAC7C,2CAA2C;IAC3C,iBAAiB;EACnB;EACA;IACE,oCAAoC;IACpC,oCAAoC;IACpC,mCAAmC;IACnC,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,gDAAgD;EAChD,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;;EAE3B;IACE,8BAA8B;IAC9B,oCAAoC;;IAEpC,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;EAChB,UAAU;EACV,qCAAqC;EACrC,oCAAoC;EACpC,sCAAsC;EACtC,gBAAgB;;EAEhB;IACE,aAAa;IACb,2BAA2B;EAC7B;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;EACjC,kCAAkC;EAClC,iDAAiD;EACjD,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE;IACE;MACE,gBAAgB;IAClB;EACF;AACF;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,WAAW;AACb","sourcesContent":[".landingPageLayout {\n  display: grid;\n  width: 100%;\n  height: 100%;\n  max-height: 100vh;\n  box-sizing: border-box;\n  gap: var(--current-grid-gutter, 24px);\n  padding: var(--current-grid-gutter, 24px);\n\n  /* Mobile: 1 column (320px ~ 599px) */\n  grid-template-columns: 1fr;\n  grid-template-rows: auto 1fr;\n  grid-template-areas:\n    'hero'\n    'content';\n}\n\n/* Tablet: 2 columns with equal proportions (600px ~ 1023px) */\n@media (min-width: 600px) {\n  .landingPageLayout {\n    grid-template-columns: 1fr 1fr;\n    grid-template-rows: 1fr;\n    grid-template-areas: 'hero content';\n    padding: 0;\n    padding-right: 8px;\n    gap: 0;\n\n    margin-left: calc(var(--current-grid-gutter, 24px) * -1);\n    padding-left: 0;\n  }\n}\n\n/* Desktop (1024px+) */\n@media (min-width: 1024px) {\n  .landingPageLayout {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n.landingPageLayoutLeft {\n  grid-area: hero;\n  min-height: 200px;\n}\n\n/* Tablet and Desktop (600px+) */\n@media (min-width: 600px) {\n  .landingPageLayoutLeft {\n    min-height: 100%;\n    max-height: 100%;\n  }\n}\n\n.landingPageLayoutLeftImageContainer {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  border-top: 1px solid var(--public-layout-separator-color);\n}\n\n.landingPageLayoutLeftImage {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.landingPageLayoutLeftTopText {\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  top: 126px;\n  z-index: 2;\n  color: var(--image-text-color);\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  h2 {\n    font-family: var(--image-heading-font-family);\n    font-size: var(--type-heading-lg-font-size);\n    text-wrap: nowrap;\n  }\n  small {\n    font-size: var(--font-size-md, 16px);\n    font-family: var(--font-family-base);\n    line-height: var(--line-height-160);\n    max-width: 200px;\n    text-wrap: wrap;\n  }\n}\n\n.landingPageLayoutRight {\n  grid-area: content;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: transparent;\n  position: relative;\n  padding: var(--spacing-3, 24px);\n}\n\n.landingPageLayoutContentCard {\n  background-color: var(--product-card-background);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: var(--spacing-3, 24px);\n\n  h3 {\n    font-size: var(--font-size-xl);\n    font-family: var(--font-family-base);\n\n    text-align: center;\n  }\n}\n\n.landingPageLayoutContentCardList {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3, 24px);\n  list-style: none;\n  padding: 0;\n  padding-right: var(--spacing-2, 16px);\n  font-size: var(--font-size-md, 16px);\n  color: var(--product-card-title-color);\n  text-align: left;\n\n  li {\n    display: flex;\n    gap: var(--spacing-2, 16px);\n  }\n}\n\n.iconContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: auto;\n  width: var(--font-size-3xl, 32px);\n  height: var(--font-size-3xl, 32px);\n  background: var(--product-card-icon-container-bg);\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.empresa {\n  .landingPageLayoutLeftTopText {\n    small {\n      max-width: 290px;\n    }\n  }\n}\n\n.escritorio {\n  background-color: var(--public-layout-background-color);\n}\n\n.landingPageLayoutContentCardButton {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"landingPageLayout": `Cv2oJS`,
	"landingPageLayoutLeft": `hA_WCy`,
	"landingPageLayoutLeftImageContainer": `fzB687`,
	"landingPageLayoutLeftImage": `JLDxUW`,
	"landingPageLayoutLeftTopText": `Imk5Gb`,
	"landingPageLayoutRight": `QeU160`,
	"landingPageLayoutContentCard": `HQMmFC`,
	"landingPageLayoutContentCardList": `M56Btd`,
	"iconContainer": `in3V9L`,
	"empresa": `DWuF9H`,
	"escritorio": `uuGG20`,
	"landingPageLayoutContentCardButton": `HfKYUE`
};
module.exports = ___CSS_LOADER_EXPORT___;
